import React, { useState } from 'react';
import { Button, ErrorSummary } from 'govuk-react-jsx';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  addIndividualChargepointDetails,
  getGrantTypeSelected,
} from '../../features/installer/installerJourneySlice';
import { addAdditionalChargepointModel } from '../../firebase';
import { getApplicationDocumentId } from '../../features/application/applicationJourneySlice';
import ChargepointSelect from './ChargepointSelect';
import useTitle from '../../hooks/useTitle';

const AddAdditionalChargepoints = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'installer.AddAdditionalChargepoints.s10',
    'What chargepoint model do you want to add? - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );

  const [chargepointManufacturer, setChargepointManufacturer] = useState('');
  const [chargepointModel, setChargepointModel] = useState('');
  const [chargepointModelSockets, setChargepointModelSockets] = useState('');
  const [chargepointNumber, setChargepointNumber] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [selectChargepointError, setSelectChargepointError] = useState([]);

  const dispatch = useDispatch();
  const history = useHistory();

  const documentId = useSelector(getApplicationDocumentId);

  const grantType = useSelector(getGrantTypeSelected);
  const residential = grantType === 'LANDLORD_RESIDENTIAL_GRANT';

  const handleAdditionalChargepointManufacturer = (value) => {
    setChargepointModel('');
    setChargepointManufacturer(() => value);
  };

  const handleAdditionalChargepointModel = (value, numberOfSocketsModel) => {
    setChargepointModel(value);
    setChargepointModelSockets(numberOfSocketsModel);
  };

  const handleAdditionalChargepoints = (value) => {
    setChargepointNumber(value);
  };

  const hasErrorCallback = (value) => {
    setHasError(value);
  };

  const handleBtnClick = () => {
    setIsSubmitted(true);
    if (!hasError) {
      addAdditionalChargepointModel({
        documentId,
        chargepointModel: {
          manufacturer: chargepointManufacturer,
          model: chargepointModel,
          socket: chargepointModelSockets,
          totalInstalled: chargepointNumber,
        },
      })
        .then((response) => {
          const { data } = response;
          const { chargepointsDetails } = data;
          dispatch(addIndividualChargepointDetails(chargepointsDetails));
          history.push('/installer/chargepoints-summary');
        })
        .catch(() => {
          // TODO: Show error
        });
    }
  };

  const pageModel = (
    <>
      {selectChargepointError.length > 0 && (
        <ErrorSummary
          errorList={selectChargepointError.map((c) => ({
            children: c.text.children,
            href: c.href,
          }))}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy(
          'installer.AddAdditionalChargepoints.s1',
          'What chargepoint model do you want to add?'
        )}
      </h1>
      <ChargepointSelect
        residential={residential}
        manufacturer={chargepointManufacturer}
        model={chargepointModel}
        count={chargepointNumber}
        onChangeManufacturer={handleAdditionalChargepointManufacturer}
        onChangeModel={handleAdditionalChargepointModel}
        onChangeCount={handleAdditionalChargepoints}
        isSubmitted={isSubmitted}
        hasError={hasErrorCallback}
        setSelectChargepointError={setSelectChargepointError}
      />
      <div className="govuk-button-group">
        <Button onClick={handleBtnClick}>
          {copyProvider.getCopy(
            'installer.AddAdditionalChargepoints.s5',
            'Save and return'
          )}
        </Button>
      </div>
    </>
  );
  return pageModel;
};

export default AddAdditionalChargepoints;
